import * as React from 'react';
import { CUSTOM_SCROLL_CSS } from './TransformHtmlViewer';
import { generateCssForMarkdown } from '../../../../../../alan_btn/src/styles/markdown';
import { processFormulas } from '../../../../../../alan_btn/src/textChat/mathjax';
import { highlightCode, initHighlightJs } from '../../../../../../alan_btn/src/textChat/highlightJs';
import { getCssForCommandsBlock } from '../../../../../../alan_btn/src/styles/chat';
import { iFrameSizeListenerFunctions, onIFrameSizeListener } from '../../../../../../alan_btn/src/textChat/helpers/adjustIFrameSize';

const styles = `
${generateCssForMarkdown('', '')}
${getCssForCommandsBlock('', '')}
`;

type TransformHtmlViewerProps = {
  value: string
}

(window as any).alanProcessFormulas = processFormulas;
(window as any).initHighlightJs = initHighlightJs;
(window as any).highlightCode = highlightCode;

const functionsToInsert = iFrameSizeListenerFunctions.map(fn => fn.toString()).join('\n\n');

const onIFrameSizeListenerString = onIFrameSizeListener.toString();

export function TransformMarkdownViewer({ value }: TransformHtmlViewerProps) {
  return <iframe
    title="preview-frame"
    width="100%"
    height="100%"
    srcDoc={`
        ${CUSTOM_SCROLL_CSS}
        <style>
        ${styles}

        body {
          white-space: normal;
        }

        .alan-special-markdown-tag-wrapper {
          white-space: pre;
          margin-bottom: 14px;
        }

        .alan-special-markdown-tag-hl-green {
          background-color: #c9ffde;
          display: inline-block;
        }

        .alan-special-markdown-tag-hl-blue {
          background-color: #a3daff;
          display: inline-block;
        }

        .alan-special-markdown-tag-hl-red {
          background-color: #ffc9c9;
          display: inline-block;
        }

        .alan-special-markdown-tag-hl-grey {
          background-color: #abadac72;
          display: inline-block;
        }

        code, code span, pre, pre code {
            font-size: 13px !important;
        }

        </style>
        ${value}
        <script>
        parent.initHighlightJs('light', document);
        parent.highlightCode(document.body);

        parent.alanProcessFormulas(document.body);

        ${functionsToInsert}
        window.addEventListener("message", ${onIFrameSizeListenerString});
        </script>
        `}
  />;
}
